module.exports = __webpack_public_path__ + "img/ring_y_c_1_null.4a5bba1a.png";